import { mdiAccountCheck } from '@mdi/js';
import { Icon } from '@mdi/react';
import React from 'react';
import { Tooltip } from '../base/tooltip';
import * as S from './done-button.styles';

interface IProviderDoneButtonProps {
    count?: number;
    disabled?: boolean;
    onClick: () => void;
}

export const ProviderDoneButton: React.FunctionComponent<IProviderDoneButtonProps> = (
    props: IProviderDoneButtonProps,
): React.ReactElement => {
    const { count, disabled, onClick } = props;
    const message = count
        ? `Move ${count} messages to Done as Provider`
        : 'Move to Done as Provider';

    return (
        <Tooltip direction="top" title={<span>{message}</span>}>
            <S.DoneButton variant="outlined" onClick={onClick} disabled={disabled}>
                <Icon path={mdiAccountCheck} size={1} />
            </S.DoneButton>
        </Tooltip>
    );
};

